export default "__VITE_ASSET__fd322aab__"